import { offers } from '@/services';

export default ({

  namespaced: true,

  state: {
    pages: null,
    faq: null,
  },

  getters: {
    pages(state){
      return state.pages;
    },
    faq(state){
      return state.faq;
    },

  },
    // Mutations alteram um ou mais 'States'
  mutations: {
    // Recebe o estado e os 'dados'
    setPages(state, data){
      state.pages = data;
    },
    setFaq(state, data){
      state.faq = data;
    },
  },
  // Ações chamam as 'mutations'
  actions: {
    async getData({ commit }){

      try {
        const pages = await offers.getPagesApp({limit: 1, offset: 1});
        const faq = await offers.getFaq({limit: 1, offset: 1});

        // Chama a 'mutation' e envia os 'dados'
        commit('setPages', pages.data);
        commit('setFaq', faq.data);
        
      } catch (error) {
          console.error('Erro ao carregar os dados:', error);
          throw error;
      }
    },

    async getFaq({ commit }){
      try {
        const faq = await offers.getFaq({limit: 1, offset: 1});
        commit('setFaq', faq.data);
      } catch (error) {
        console.error('Erro ao carregar os dados:', error);
        throw error;
      }
    },
    async getPages({ commit }){
      try {
        const pages = await offers.getPagesApp({limit: 1, offset: 1});
        commit('setPages', pages.data);
      } catch (error) {
        console.error('Erro ao carregar os dados:', error);
        throw error;
      }
    },

  },

})
